var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrainElectricity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37387 12.167C4.99315 12.167 3.87387 13.2863 3.87387 14.667C3.87387 16.0477 4.99315 17.167 6.37387 17.167C6.66606 17.167 6.94655 17.1169 7.2072 17.0247",
    stroke: "#2E4D6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0938 13.5043C2.97745 12.9656 2.20723 11.823 2.20723 10.5005C2.20723 9.49074 2.65618 8.58589 3.36535 7.97461",
    stroke: "#2E4D6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39097 7.90716C3.16961 7.57623 3.04053 7.17835 3.04053 6.75033C3.04053 5.59973 3.97327 4.66699 5.12387 4.66699C5.59296 4.66699 6.02584 4.82203 6.37407 5.08366",
    stroke: "#2E4D6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57194 5.1381C6.44489 4.86878 6.37386 4.56785 6.37386 4.25033C6.37386 3.09973 7.3066 2.16699 8.45719 2.16699C9.60779 2.16699 10.5405 3.09973 10.5405 4.25033V17.167",
    stroke: "#2E4D6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20719 17.167C7.20719 18.0875 7.95339 18.8337 8.87386 18.8337C9.79434 18.8337 10.5405 18.0875 10.5405 17.167",
    stroke: "#2E4D6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5406 6.33301C10.5406 7.71372 11.6598 8.83301 13.0406 8.83301",
    stroke: "#2E4D6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7157 7.97461C18.4249 8.58589 18.8739 9.49074 18.8739 10.5005C18.8739 11.0864 18.7227 11.637 18.4572 12.1154",
    stroke: "#2E4D6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6901 7.90716C17.9115 7.57623 18.0406 7.17835 18.0406 6.75033C18.0406 5.59973 17.1078 4.66699 15.9572 4.66699C15.4881 4.66699 15.0552 4.82203 14.707 5.08366",
    stroke: "#2E4D6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5406 4.25033C10.5406 3.09973 11.4733 2.16699 12.6239 2.16699C13.7745 2.16699 14.7072 3.09973 14.7072 4.25033C14.7072 4.56785 14.6362 4.86878 14.5091 5.1381",
    stroke: "#2E4D6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2072 18.8337C11.2867 18.8337 10.5406 18.0875 10.5406 17.167",
    stroke: "#2E4D6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0961 13.833L14.7072 16.333H18.0405L16.6516 18.833",
    stroke: "#2E4D6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainElectricity);
export default __webpack_public_path__ + "static/media/brain-electricity.09f6532deb2c0f85a3ddbbe573f30cba.svg";
export { ForwardRef as ReactComponent };